import { createElement, FC, useContext } from 'react';

import Language from '../../entity/Language';
import Component from '../component/compound/HeadBar';
import { context as ConfigContext } from '../context/config';
import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';

type Props = {
  className?: string;
};

const HeadBar: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);
  const config = useContext(ConfigContext);
  const drawerOpen = state.drawerOpen;
  const organizations = state.organization.organizations;
  const currentOrgOrAccount = state.currentOrgOrAccount;
  const signedInUser = state.authentication.signedInUser;
  const mfaSetupRequired = !!signedInUser && !!signedInUser.mfaRequired && !signedInUser.otpEnabled;

  return !state.fatalError &&
    (mfaSetupRequired || !state.authentication.done) &&
    state.authentication.fetching === 0 &&
    signedInUser &&
    !state.location.pathname.includes('questionnaire') ? (
    <Component
      signedInUser={signedInUser}
      profileWebUrl={`${config.PROFILE_WEB_URL}/users/${signedInUser.id}`}
      onClickSignOut={() => dependency.authenticationUsecase.signOut()}
      triggerDrawer={() => dependency.drawerOpenUsecase.setOpen(!drawerOpen)}
      organizations={organizations}
      onSubmit={(lang: Language) => dependency.userUsecase.updateUserLang(lang)}
      currentOrgOrAccount={currentOrgOrAccount}
      setCurrentOrgOrAccount={dependency.organizationUsecase.setCurrentOrgOrAccount}
      drawerOpen={drawerOpen}
      limited={mfaSetupRequired}
      className={className}
    />
  ) : null;
};

export default HeadBar;
